export const dataSelectWorkflow = [
  {
    _id: '64114e7f56245d2f3ecb380f',
    name: 'Workflow 1',
    isCont: true
  },
  {
    _id: '641190b37cdd3ef86cc7eb70',
    name: 'Workflow 2',
    isCont: false
  }
]

export const contTypes = () => {
  return [
    {
      value: 20,
      label: $t('labels.vehicleModule.20ft')
    },
    {
      value: 40,
      label: $t('labels.vehicleModule.40ft')
    },
    {
      value: 45,
      label: $t('labels.vehicleModule.45ft')
    }
  ]
}

export const createPriceFromOptions = () => {
  return [
    {
      value: 1,
      label: $t('labels.quote')
    },
    {
      value: 2,
      label: $t('labels.quoteRequest')
    },
    {
      value: 3,
      label: $t('labels.handmade')
    }
  ]
}

export const getTypeCommodity = (data: any) => {
  const results: string[] = []
  if (data.goodType === 'LIQUID') {
    results.push('LIQUID')
  }

  if (data.goodType === 'GAS') {
    results.push('GAS')
  }

  if (data.typeDangerous === 'DANGEROUS') {
    results.push('DANGEROUS')
  }

  if (data.typeFragileGoods === 'FRAGILE') {
    results.push('FRAGILE')
  }

  if (data.typeReefer === 'REEFER') {
    results.push('FROZEN')
  }

  if (data.typeCommodity === 'OVERWEIGHT') {
    results.push('OVERWEIGHT')
  }

  return results.length > 0 ? results : ['NORMAL']
}

export const getPriceFromLabel = (key: number) => {
  switch (key) {
    case 1:
      return $t('labels.quote')
    case 2:
      return $t('labels.quoteRequest')
    case 3:
      return $t('labels.handmade')
    default:
      return ''
  }
}

export interface IVendorPrice {
  _id?: String
  createPriceFrom?: number
  quote?: string | null
  type?: string | number
  quoteCode?: string | null
  quoteRequest?: string | null
  quoteRequestCode?: string | null
  vendor: String | null | any
  vendorName?: String | null
  contact: String | null | any
  contactName?: String | null
  email: String | null
  phone: String | null
  workflow: String | null
  contCategory: string | null
  vehicleCategory: string | null
  vehicleCategoryName?: string | null
  theSamePositions: Array<Array<number>> | undefined
  workflowName?: String | null
  transportation: String | null
  positions: Array<{ [key: string]: any }>
  effectiveFromDate: string | Date | null
  effectiveToDate: string | Date | null
  price: Number | null | undefined
  oilPrice: Number | null | undefined
  tasks: Array<{ [key: string]: any }>
  acceptPriceOfflineFee?: Array<{ [key: string]: any }>
  typeCommodity: Array<string>
  description?: string | null | undefined
  mergeContainer: boolean
  weightCommodity: null
  minWeightCommodity?: null
  priceOfflineFee: any[]
  headContainer: boolean
}

export const initAdd: IVendorPrice = {
  createPriceFrom: 1,
  vendor: null,
  contact: null,
  email: null,
  phone: null,
  workflow: null,
  transportation: '',
  contCategory: '',
  vehicleCategory: '',
  positions: [],
  tasks: [],
  typeCommodity: [],
  theSamePositions: [],
  effectiveFromDate: null,
  effectiveToDate: null,
  oilPrice: null,
  price: null,
  weightCommodity: null,
  mergeContainer: false,
  priceOfflineFee: [],
  headContainer: false
}

export const getWorkflowName = (id: String) => {
  const data = dataSelectWorkflow.filter((workflow) => workflow._id === id)
  if (Array.isArray(data)) {
    return data[0].name
  }

  return ''
}

export const numberFormatter = (number: number | string) => {
  try {
    const parts = number.toString().split('.')
    if (parts.length > 2) {
      return number.toString()
    }
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
  } catch (e: any) {
    return number.toString()
  }
}
